import axios from 'axios';
import moment from 'moment';

// Used for to populate gym_common state on initial load and reset gym_common state on logout
const getGymCommonDefaultState = () => {
  return {
		fitnessData: null,
		loadingFitnessData: false,
		fitnessDataLoadedWithLocale: null,
		selectedDate: new Date(),
		ownEvents: false,
		ownEventsObject: false,
		selectedCategory: null,
		selectedFitnessLocation: null,
		appAuth:  null,
		customerTermsArticleId: null,
		entriesCount: null,
  }
}

export default {
	namespaced: true,
	state: getGymCommonDefaultState(),
	getters: {
		// Check if location check is required, or is inside any location, or have successful location validation in settings.fitness_eventConfirm.ifDoorOpenedInLastMinutes
		// Updates everytime when user cordinates change or successfull location validation timestamp change
		canUserConfirm: (state, getters, rootState) => {
			console.log("gym_common: getters: canUserConfirm")
			// Check if location check is needed to confirm event
			if(rootState.common.settings.fitness_eventConfirm?.requireLocationCheck !== true) {
				return true
			}

			// Check if last successful door open is in settings.fitness_eventConfirm.ifDoorOpenedInLastMinutes
			if(rootState.door.successfulLocationValidation.timestamp !== null) {
				const successfullDoorOpenDateTime = moment.unix(rootState.door.successfulLocationValidation.timestamp).format('DD.MM.YYYY HH:mm')
				const minutesFromSuccessfulDoorOpen =  Math.abs(moment(successfullDoorOpenDateTime, 'DD.MM.YYYY HH:mm').utcOffset(0, true).diff(moment().utcOffset(0, true), 'minutes'))
				return minutesFromSuccessfulDoorOpen <= rootState.common.settings.fitness_eventConfirm?.ifDoorOpenedInLastMinutes
			}

			// If we are here user can not confirm event
			return false
		}
	},
	mutations: {
		mutateGymCommonStateToDefault(state) {
			Object.assign(state, getGymCommonDefaultState())
		},
		mutateFitnessData(state, fitnessData) {
			state.fitnessData = fitnessData;
			//console.log(state.fitnessData)
		},
		mutateLoadingFitnessData(state, loadingFitnessData) {
			state.loadingFitnessData = loadingFitnessData;
		},
		mutatefitnessDataLoadedWithLocale(state, fitnessDataLoadedWithLocale) {
			state.fitnessDataLoadedWithLocale = fitnessDataLoadedWithLocale;
		},
		mutateSelectedDate(state, selectedDate) {
			state.selectedDate = selectedDate;
		},

		mutateSelectedCategory(state, selectedCategory) {
			state.selectedCategory = selectedCategory;
		},
		mutateSelectedFitnessLocation(state, selectedFitnessLocation) {
			state.selectedFitnessLocation = selectedFitnessLocation;
		},
		mutateHandleFitnessEvent(state, event) {
			const eventIndex = state.fitnessData.events.findIndex(eventItem => eventItem.activityId === event.activityId)
			state.fitnessData.events[eventIndex] = event
			// console.log(state.fitnessData)
		},
		mutateMarkAttendance(state, data) {
			const eventIndex = state.fitnessData.events.findIndex(eventItem => eventItem.activityId === data.activityId)
			const attendeeIndex = state.fitnessData.events[eventIndex].eventAttendees.findIndex(attendee => attendee.attendeeId === data.attendeeMark.attendeeId)
			state.fitnessData.events[eventIndex].eventAttendees[attendeeIndex].markedAttendance = data.attendeeMark.markedAttendance
		},
		mutateOwnEvents(state, ownEvents) {
			state.ownEvents = ownEvents;
		},
		mutateOwnEventsObject(state, ownEventsObject) {
			state.ownEventsObject = ownEventsObject;
		},
		mutateCanUserConfirm(state, canUserConfirm) {
			state.canUserConfirm = canUserConfirm;
		},
		mutateEntriesCount(state, entriesCount) {
			state.entriesCount = entriesCount;
		}
	},

	actions: {
		async getFitnessData({ rootGetters, commit, rootState }) {

			// WiseSettings.js useFitness controls tabs and api calls
			const useFitness = rootGetters["common/activeHost"].useFitness

			if (useFitness) {
				console.log("gym_common: getFitnessData()")

				// Only show loading on initial fetch, when updating fitness data no need to show loading
				if(rootState.gym_common.fitnessDataLoadedWithLocale === null) {
					commit('mutateLoadingFitnessData', true)
				}

				// Get fitness data, Filter events to categories, Init fitness data update interval
				try {
					const fitnessData = await axios.get(`${rootGetters["common/activeHost"].ajaxUrl}?controller=ajax&fitnessdata=1&lang=${rootState.common.userLocale}&appauth=${rootGetters["common/activeHost"].appauth}`)

					// If have categories
					if (fitnessData.data.categories !== false) {
						fitnessData?.data?.categories?.forEach((category, index) => {
							fitnessData.data.categories[index].events = fitnessData.data.events.filter(event => event.eventCategoryId === category.eventCategoryId)
						})
					}
					
					commit('mutateFitnessData', fitnessData?.data)
					commit('mutateLoadingFitnessData', false)

					const ownEvents = fitnessData.data.events.filter(event => event.eventAttendees?.find(attendee => attendee?.personId === rootState.user?.user?.personId))
					//Store to state.gym_common.ownEvents
					commit('mutateOwnEventsObject', ownEvents)
				} catch (error) {
					console.error(error)
					commit('mutateFitnessData', null)
					commit('mutateLoadingFitnessData', false)
					return Promise.reject(error)
				}
			}
		},

		async getEntriesCount({ commit}) {
			//console.log("getEntriesCount()")
			try {
				const data = Math.floor(Math.random() * 35)
				commit('mutateEntriesCount', data)
			} catch (error) {
				console.log(error)
			}

		},

		async handleFitnessEvent({ rootGetters, commit, rootState }, data) {
			const eventHandleData = {
				action: data.action,
				activityId: data.event.activityId,
				hash: data.event.hash,
				isMobile: true,
				isUserLocal: false,
				personId: rootState.user.user.personId,
				tagData: false
			}

			try {
				const { data } = await axios.post(`${rootGetters["common/activeHost"].ajaxUrl}?controller=ajax&handleevent=1&lang=${rootState.common.userLocale}&appauth=${rootGetters["common/activeHost"].appauth}`, eventHandleData)
				if (Object.keys(data)[0] === 'error') {
					return Promise.reject(data.error)
				}
				commit('mutateHandleFitnessEvent', data.event)

				return data
			} catch (error) {
				console.error(error)
				throw(error)
			}
		},

		async markFitnessAttendance({ rootGetters, commit, rootState }, attendee) {
			const attendeeMark = {
				attendeeId: attendee.attendeeId,
				markedAttendance: attendee.markedAttendance
			}

			try {
				const { data } = await axios.post(`${rootGetters["common/activeHost"].ajaxUrl}?controller=ajax&markattendance=1&lang=${rootState.common.userLocale}&appauth=${rootGetters["common/activeHost"].appauth}`, attendeeMark)
				if (Object.keys(data)[0] === 'error') {
					return Promise.reject(data.error)
				}
				commit('mutateMarkAttendance', { attendeeMark, activityId: attendee.activityId })

				return data
			} catch (error) {
				console.error(error)
				throw(error)
			}
		},
	}
}